import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import Approval from './Approval'
import Folders from './Folders'

interface Props {
  addon: SubscriptionAddon
}

const Content = ({ addon }: Props) => (
  <Box>
    <Folders addon={addon} />
    <Box paddingTop="s48">
      <Approval addon={addon} />
    </Box>
  </Box>
)

export default Content
